
import XHeader from 'vux/src/components/x-header/index.vue'



export default {
name: 'customSuccess',
components: {
XHeader,
},

methods: {
gotolist() {
this.$router.push({ name: 'travel-order-list' })
},
back() {
this.$router.push({
name: 'sports-tour-list',
query: {
routeType: 2,
},
})
},
},
}




// WEBPACK FOOTER //
// ./client/components/SportsTour/CustomSuccess.vue